import { selectIsLoggedIn, selectUserId } from '@/features/user/selectors';

import { createSelector } from '@reduxjs/toolkit';
import { head, pipe, prop, propOr } from 'ramda';

export const getAuth = (state) => state.auth;

export const getUser = createSelector(getAuth, (auth) => auth.user || {});

export const getUserId = createSelector(getUser, prop('id'));

export const getIsMfaLoading = createSelector(getAuth, prop('mfaLoading'));
export const selectIsSignInLoading = createSelector(getAuth, prop('isSignInLoading'));
export const getMfaDevice = createSelector(getUser, pipe(propOr([], 'mfa_devices'), head));
export const selectAuthError = createSelector(getAuth, prop('error'));

export const selectShouldShowLoginForm = createSelector(
  [selectIsLoggedIn, selectUserId],
  (isLoggedIn, userId) => !isLoggedIn && !userId //&& !isAuthLoading
);
